import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
})
export class PromptDialogComponent {
  @Input() status: string;
  @Input() header: string;
  @Input() body: string;
  @Input() btn_action_name: string = 'Confirm';
  @Input() btn_cancel_name: string = 'Close';
  @Input() show_cancel_button: boolean = true;

  constructor(protected ref: NbDialogRef<PromptDialogComponent>) {}

  setIcon(status) {
    if (status === 'danger') {
      return 'close-circle-outline';
    } else if (status === 'warning') {
      return 'alert-circle-outline';
    } else if (status === 'info') {
      return 'info-outline';
    } else if (status == 'success') {
      return 'checkmark-circle-2-outline';
    } else {
      return 'info-outline';
    }
  }

  dismiss() {
    this.ref.close({ event: false });
  }

  confirm() {
    this.ref.close({ event: true });
  }
}
